<div class="header">
  <spb-logo [routePath]="['/']" title=""/>
  <div style="flex-grow: 1"></div>
  <div style="margin-right: 10px">
    <spb-toggle-button/>
  </div>
</div>